var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2015_2720",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 21,
    width: 14,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.3198H26V28.0001H12V21.3198Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2015_2720)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0009 22.6777C15.2349 22.6777 13.3258 23.3409 13.3258 24.6499C13.3258 25.9708 15.2349 26.6402 19.0009 26.6402C22.7661 26.6402 24.6743 25.9771 24.6743 24.668C24.6743 23.3472 22.7661 22.6777 19.0009 22.6777ZM19.0009 27.9991C17.2695 27.9991 12 27.9991 12 24.6499C12 21.664 15.9959 21.3188 19.0009 21.3188C20.7324 21.3188 26.0001 21.3188 26.0001 24.668C26.0001 27.654 22.0051 27.9991 19.0009 27.9991Z",
    fill: "#1A1B20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2015_2720",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 10,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3066 10H23.693V19.6196H14.3066V10Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2015_2720)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0025 11.2932C17.1102 11.2932 15.5705 12.8704 15.5705 14.81C15.5643 16.7432 17.0925 18.3196 18.9768 18.3268L19.0025 18.9736V18.3268C20.8939 18.3268 22.4327 16.7487 22.4327 14.81C22.4327 12.8704 20.8939 11.2932 19.0025 11.2932ZM19.0011 19.62H18.9728C16.3902 19.6118 14.2981 17.453 14.307 14.8077C14.307 12.1579 16.4123 10 19.0011 10C21.589 10 23.6934 12.1579 23.6934 14.8105C23.6934 17.463 21.589 19.62 19.0011 19.62Z",
    fill: "#1A1B20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSimple);
export default __webpack_public_path__ + "static/media/profile-simple.ae7acf4e4bd5894f312bd0f15d885dcc.svg";
export { ForwardRef as ReactComponent };